import React from "react";
import { Tabs } from "antd";
import {
  FileTextOutlined,
  BarsOutlined,
  LineChartOutlined,
  SettingOutlined,
  OrderedListOutlined,
} from "@ant-design/icons";
import "./index.css";
import SingleAssignment from "./components/SingleAssignment/SingleAssignment";
import BatchGrading from "./components/BatchGrading/BatchGrading";
import Analytics from "./components/Analytics/Analytics";
import Settings from "./components/Settings/Settings";
import RubricsView from "./components/RubricsView/RubricsView";
import { useIntelligentGrading } from "../../context/useIntelligentGrading";
import { useAssignment } from "../../../../context/AssignmentContext";

const { TabPane } = Tabs;

const brandColor = "#6264a7";

const SummaryPage = () => {
  const { activeTab, setActiveTab, user, selectedSubmission } = useIntelligentGrading();
  const { currentAssignmentData } = useAssignment();

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  const tabItems = [
    {
      key: "single",
      label: (
        <span>
          <FileTextOutlined style={{ color: brandColor }} />
          Single Assignment
        </span>
      ),
      children: <SingleAssignment />,
    },
    {
      key: "batch",
      label: (
        <span>
          <BarsOutlined />
          Batch Grading
        </span>
      ),
      children: <BatchGrading />,
    },
    {
      key: "rubrics",
      label: (
        <span>
          <OrderedListOutlined />
          Rubrics
        </span>
      ),
      children: <RubricsView rubrics={currentAssignmentData?.rubric} />,
    },
    {
      key: "analytics",
      label: (
        <span>
          <LineChartOutlined />
          Analytics
        </span>
      ),
      children: <Analytics user={user} />,
    },
    // {
    //   key: "settings",
    //   label: (
    //     <span>
    //       <SettingOutlined />
    //       Settings
    //     </span>
    //   ),
    //   children: <Settings />,
    // },
  ];

  return (
    <Tabs
      activeKey={activeTab}
      onChange={handleTabChange}
      items={tabItems}
      tabBarStyle={{
        borderBottom: `2px solid #f0f0f0`,
        marginBottom: 24,
      }}
      tabBarGutter={32}
      moreIcon={null}
      indicator={{
        style: { background: brandColor, height: 3 },
      }}
    />
  );
};

export default SummaryPage;
